import { AppBar, Toolbar, Typography, Box, Button } from "@mui/material";

import LogoutIcon from '@mui/icons-material/Logout';

export default function HeaderUI({ title, onLogout }) {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#b0b0b0",
        color: "#0b0b0b",
        boxShadow: "none",
        height: "12%",
        width: "84vw",
        justifyContent: "center",
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1, textAlign: "center" }}>
          <Typography sx={{ fontSize: {md: "40px", sm: "30px"} }}>
            {title}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          Cerrar sesión
          <Button color="inherit" onClick={onLogout}>
            <LogoutIcon />
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}